import React from 'react';
import Flag from 'react-world-flags';

// DEFAULT CURRENCY
// IDR = Rp
// SGD = $

export const DEFAULT_COUNTRY_CODE = process.env.REACT_APP_COUNTRY || 'ID';
export const DEFAULT_CURRENCY = DEFAULT_COUNTRY_CODE === 'SG' ? '$' : 'Rp';

export const countryOptions = [
    {
        code: 'SG',
        name: 'Singapore',
        url: 'https://sg.iwant-asia.com',
        image: <Flag code="SG" style={{ width: 50, height: 30, borderRadius: 4, objectFit: 'cover' }} />
    },
    {
        code: 'ID',
        name: 'Indonesia',
        url: 'https://id.iwant-asia.com',
        image: <Flag code="ID" style={{ width: 50, height: 30, borderRadius: 4, objectFit: 'cover' }} />
    },
    {
        code: 'MY',
        name: 'Malaysia',
        url: 'https://my.iwant-asia.com',
        image: <Flag code="MY" style={{ width: 50, height: 30, borderRadius: 4, objectFit: 'cover' }} />,
        disabled: true
    },
    {
        code: 'VN',
        name: 'Vietnam',
        url: 'https://vn.iwant-asia.com',
        image: <Flag code="VN" style={{ width: 50, height: 30, borderRadius: 4, objectFit: 'cover' }} />,
        disabled: true
    },
    {
        code: 'TH',
        name: 'Thailand',
        url: 'https://th.iwant-asia.com',
        image: <Flag code="TH" style={{ width: 50, height: 30, borderRadius: 4, objectFit: 'cover' }} />,
        disabled: true
    }
    // { code: 'CN', name: 'China', url: 'https://cn.iwant-asia.com' },
    // Add more countries as needed
];

export const formatCurrency = (value) => {
    let currencyconvertion = DEFAULT_CURRENCY === '$' ? 'SGD' : 'IDR';
    let localizationconvert = DEFAULT_CURRENCY === '$' ? 'en-SG' : 'en-US';

    return new Intl.NumberFormat(localizationconvert, {
        style: 'currency',
        currency: currencyconvertion,
        currencyDisplay: 'narrowSymbol',
        maximumFractionDigits: currencyconvertion === 'IDR' ? 0 : 2 // No decimal for IDR, 2 decimals for SGD
    }).format(value);
};
